<head>
  <link rel="stylesheet" href="https://cdnjs.cloudflare.com/ajax/libs/font-awesome/6.4.0/css/all.min.css"
    integrity="sha512-iecdLmaskl7CVkqkXNQ/ZH/XLlvWZOJyj7Yy7tcenmpD1ypASozpmT/E0iPtmFIB46ZmdtAc9eNBvH0H/ZpiBw=="
    crossorigin="anonymous" referrerpolicy="no-referrer" />
</head>
<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>
<div class="homePage">
  <div style="visibility: hidden; position: fixed" [style.left]="menuTopLeftPosition.x"
    [style.top]="menuTopLeftPosition.y" [matMenuTriggerFor]="rightMenu"></div>
  <mat-menu #rightMenu="matMenu">
    <ng-template matMenuContent let-item="item" style="width:120px !important">
      <button class="right_click_border" *ngFor="let button of item" mat-menu-item
        (click)="performOperationFunc(button)">
        <div class="d-flex gap-2 align-items-center">
          <span> <img style="width: 18px;height: 18px;" class="svg_dimension" src="../../assets/img/untag.png"
              alt="" /></span>
          <span class="right_click_actions">&nbsp;&nbsp;{{button.text}}</span>
        </div>
      </button>
    </ng-template>
  </mat-menu>
</div>
<div class="" style="margin-top: 2%;">
  <div class="row" *ngIf="myTagsList.length > 0">
    <div class="d-flex thumbnail">
      <div class="d-flex">
        <div style="display: grid;text-align: center;margin-right:1%;cursor: pointer;" *ngFor="let tag of myTagsList"
          (click)="navigate(tag)" (contextmenu)="onRightClick($event, tag)">
          <svg style="margin-left:30%" *ngIf="tag.module == 'CR'" width="30" height="30" viewBox="0 0 24 25" fill="none"
            xmlns="http://www.w3.org/2000/svg" matTooltip="{{tag.tagRef}}">
            <path
              d="M9.8998 22.347H5.69979C4.37431 22.347 3.2998 21.2725 3.2998 19.947L3.2999 5.54708C3.29991 4.2216 4.37442 3.14709 5.6999 3.14709H16.5002C17.8256 3.14709 18.9002 4.22161 18.9002 5.54709V6.74707M14.1428 21.1471L11.7002 18.6928M11.7002 18.6928L14.0323 16.3471M11.7002 18.6928H18.9273C19.9064 18.6928 20.7002 17.8991 20.7002 16.92M17.5574 9.74707L20 12.2013M20 12.2013L17.6678 14.5471M20 12.2013H12.7729C11.7937 12.2013 11 12.9951 11 13.9742"
              stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <img *ngIf="tag.module == 'CAPA'" matTooltip="{{tag.tagRef}}" class="svg_dimension"
            src="../../assets/img/CAPA.svg" alt="" />
          <img *ngIf="tag.module == 'DV'" matTooltip="{{tag.tagRef}}" class="svg_dimension"
            src="../../assets/img/Deviations.svg" alt="" />
          <img *ngIf="tag.module == 'AU'" matTooltip="{{tag.tagRef}}" class="svg_dimension"
            src="../../assets/img/Audit_cr.svg" alt="" alt="" />
          <img *ngIf="tag.module == 'QI'" matTooltip="{{tag.tagRef}}" class="svg_dimension"
            src="../../assets/img/Quality Issues.svg" alt="" />
          <img *ngIf="tag.module == 'CC'" matTooltip="{{tag.tagRef}}" class="svg_dimension"
            src="../../assets/img/Customer Complaints.svg" alt="" />
          <img *ngIf="tag.module == 'IN'" matTooltip="{{tag.tagRef}}" class="svg_dimension"
            src="../../assets/img/investigation.png" alt="" />
          <svg style="margin-left:30%" *ngIf="tag.module == 'DMS'" matTooltip="{{tag.tagRef}}"
            xmlns="http://www.w3.org/2000/svg" width="30" height="30" viewBox="0 0 20 20" fill="none">
            <path
              d="M2.00086 7.0139L2.00078 14.6175C2.00077 15.7221 2.8962 16.6175 4.00078 16.6175L15.9997 16.6175C17.1043 16.6176 17.9997 15.7222 17.9997 14.6176L18 6.84372C18 6.29142 17.5523 5.84369 17 5.84369H10.0697L7.76555 3.38232H3.00038C2.44794 3.38232 2.00017 3.82964 2.00034 4.38207C2.00058 5.16753 2.00086 6.2523 2.00086 7.0139Z"
              stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <svg style="margin-left:30%" *ngIf="tag.module == 'FORMS'" xmlns="http://www.w3.org/2000/svg" width="30"
            height="30" viewBox="0 0 24 25" fill="none" matTooltip="{{tag.tagRef}}">
            <path
              d="M7.20002 12.1471L10.2 15.1471L7.20002 18.1471M3.00002 8.54709H21M4.80002 22.3471C3.47454 22.3471 2.40002 21.2726 2.40002 19.9471V5.54709C2.40002 4.22161 3.47454 3.14709 4.80002 3.14709H19.2C20.5255 3.14709 21.6 4.22161 21.6 5.54709V19.9471C21.6 21.2726 20.5255 22.3471 19.2 22.3471H4.80002Z"
              stroke="#005C8A" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
          <small class="smallCss">{{tag.tagRef}}</small>
        </div>
      </div>


    </div>
  </div>

  <div class="row">
    <div class="col-md-6">
      <div class="position-relative cr_content h-auto table-container thumbnail home-icons"
        style="border-radius:15px; height:188px!important;">

        <div class="icons-flex">

          <div class="icon-item" (click)="openPopup('mytask')" (keydown.enter)="openPopup('mytask')">
            <img class="o-q-i" src="../../assets/img/HomePage/MyTaskIcon.svg" alt="My Tasks"
              matTooltip="My Tasks({{myTaskCount}})">
            <span class="count bg-danger">{{myTaskCount}}</span>
            <small>My Tasks</small>
          </div>

         <div class="icon-item"
    *ngIf="organizationPrivelegesData?.isDocumentUser == 'Y' && organizationPrivelegesDetails?.docs"
    (click)="openPopup('document')" (keydown.enter)="openPopup('document')">
    <img class="o-q-i" src="../../assets/img/HomePage/MyDocuments.svg" alt="My Documents"
      matTooltip="My Documents ({{documentsCount}})">
    <span class="count bg-primary">{{documentsCount}}</span>
    <small>My Documents</small>
</div>

          <div class="icon-item" *ngIf="managerCount != 0" (click)="openPopup('user')"
            (keydown.enter)="openPopup('user')">
            <img class="o-q-i" src="../../assets/img/HomePage/MyTeam.svg" alt="My Team"
              matTooltip="My Team({{managerCount}})">
            <span class="count bg-primary">{{managerCount}}</span>
            <small>My Team</small>
          </div>

          <div class="icon-item" (click)="openPopup('topic')" (keydown.enter)="openPopup('topic')">
            <img class="o-q-i" src="../../assets/img/HomePage/Messages.svg" alt="Messages"
              matTooltip="Messages ({{messageCount}})">
            <span class="count bg-danger">{{messageCount}}</span>
            <small>Messages</small>
          </div>

          <div class="icon-item" (click)="openPopup('Events')" (keydown.enter)="openPopup('Events')">
            <img class="o-q-i" src="../../assets/img/HomePage/Events.svg" alt="Events" matTooltip="Events">
            <small>Events</small>
          </div>

          <div class="icon-item"
            *ngIf="isShowBulkUpload && organizationPrivelegesData?.isDocumentUser =='Y' && organizationPrivelegesDetails?.docs"
            (click)="openPopup('Bulk Upload')" (keydown.enter)="openPopup('Bulk Upload')">
            <img class="o-q-i" src="../../assets/img/HomePage/BulkUpload.svg" alt="Bulk Upload"
              matTooltip="Bulk Upload">
            <small>Bulk Upload</small>
          </div>

          <div class="icon-item"
            *ngIf="isShowBulkDownload && organizationPrivelegesData?.isDocumentUser =='Y' && organizationPrivelegesDetails?.docs"
            (click)="openPopup('Bulk Download')" (keydown.enter)="openPopup('Bulk Download')">
            <img class="o-q-i" src="../../assets/img/HomePage/BulkDownload.svg" alt="Bulk Download"
              matTooltip="Bulk Download">
            <small>Bulk Download</small>
          </div>

          <div class="icon-item"
            *ngIf="isShowBulkDownload && organizationPrivelegesData?.isDocumentUser =='Y' && organizationPrivelegesDetails?.docs"
            (click)="openPopup('My Issuance History')" (keydown.enter)="openPopup('My Issuance History')">
            <img class="o-q-i" src="../../assets/img/HomePage/IssuanceHistory.svg" alt="My Issuance History"
              matTooltip="My Issuance History">
            <small>My Issuance History</small>
          </div>

          <div class="icon-item" (click)="openPopup('Saved Report')" (keydown.enter)="openPopup('Saved Report')">
            <img class="o-q-i" src="../../assets/img/HomePage/SavedReports.svg" alt="Saved Report"
              matTooltip="Saved Report">
            <small>Saved Report</small>
          </div>

          <div class="icon-item" *ngIf="showRaiseIncident" (click)="openPopup('Incident')"
            (keydown.enter)="openPopup('Incident')">
            <img class="o-q-i" src="../../assets/img/HomePage/Incidents.svg" alt="Incidents" matTooltip="Incidents">
            <small>Incidents</small>
          </div>

          <div class="icon-item" *ngIf="showRaiseComplaint" (click)="openPopup('Complaint')"
            (keydown.enter)="openPopup('Complaint')">
            <img class="o-q-i" src="../../assets/img/HomePage/Complaints.svg" alt="Complaints" matTooltip="Complaints">
            <small>Complaints</small>
          </div>

          <div class="icon-item" (click)="openPopup('Notifications')" (keydown.enter)="openPopup('Notifications')">
            <img class="o-q-i" src="../../assets/img/HomePage/Notifications.svg" alt="Notifications"
              matTooltip="Notifications">
            <small>Notifications</small>
          </div>

        </div>
      </div>

      <div class="thumbnail">
        <app-calendar></app-calendar>
      </div>
    </div>

    <div class="col-md-6">
      <div class="row position-relative cr_content h-auto table-container thumbnail"
        style="border-radius: 15px; margin:5px; padding-left:0px !important; margin-left: 0px !important;">

        <div class="col-md-4 pb-2">
          <div class="row" *ngIf="userImage == null">
            <svg width="181" height="180" style="margin-top: -15%;margin-left: 10%;" viewBox="0 0 181 212" fill="none"
              xmlns="http://www.w3.org/2000/svg">
              <g clip-path="url(#clip0_4343_66862)">
                <mask id="path-1-inside-1_4343_66862" fill="white"> </mask>
                <path
                  d="M69.501 16.4626C69.501 12.3411 72.8467 8.97089 76.9566 9.27971C87.4705 10.0697 97.8083 12.5272 107.578 16.5741C119.65 21.5745 130.619 28.9036 139.859 38.1432C149.098 47.3827 156.428 58.3516 161.428 70.4236C166.428 82.4956 169.002 95.4343 169.002 108.501C169.002 121.568 166.428 134.506 161.428 146.578C156.427 158.65 149.098 169.619 139.859 178.859C130.619 188.098 119.65 195.428 107.578 200.428C97.8082 204.475 87.4704 206.932 76.9566 207.722C72.8467 208.031 69.5009 204.661 69.5009 200.539C69.5009 196.418 72.8485 193.111 76.9539 192.748C85.506 191.991 93.908 189.935 101.867 186.639C112.128 182.389 121.452 176.159 129.305 168.305C137.159 160.452 143.389 151.128 147.639 140.867C151.889 130.606 154.077 119.608 154.077 108.501C154.077 97.3943 151.889 86.3964 147.639 76.1352C143.389 65.874 137.159 56.5504 129.305 48.6968C121.452 40.8432 112.128 34.6134 101.867 30.3631C93.908 27.0665 85.5061 25.0107 76.9539 24.2542C72.8485 23.891 69.501 20.584 69.501 16.4626Z"
                  stroke="#839EFF" stroke-width="2" mask="url(#path-1-inside-1_4343_66862)" />
                <g style="mix-blend-mode:multiply" opacity="0.7">
                  <path
                    d="M58 162C87.2711 162 111 138.271 111 109C111 79.7289 87.2711 56 58 56C28.7289 56 5 79.7289 5 109C5 138.271 28.7289 162 58 162Z"
                    stroke="#839EFF" stroke-miterlimit="10" />
                </g>
                <g style="mix-blend-mode:multiply" opacity="0.7">
                  <path
                    d="M58.5 150C81.4198 150 100 131.42 100 108.5C100 85.5802 81.4198 67 58.5 67C35.5802 67 17 85.5802 17 108.5C17 131.42 35.5802 150 58.5 150Z"
                    stroke="#839EFF" stroke-width="1.19373" stroke-linecap="round" stroke-linejoin="round"
                    stroke-dasharray="1.8 4.5" />
                </g>
                <g style="mix-blend-mode:multiply" opacity="0.45">
                  <path
                    d="M56.7994 93.3541V73.0002C48.5463 73.3753 40.6857 76.6317 34.584 82.2032L48.9902 96.594C51.2313 94.7914 53.9408 93.6673 56.7994 93.3541Z"
                    fill="#839EFF" />
                  <path
                    d="M48.9902 120.406L34.584 134.817C40.6922 140.376 48.5504 143.624 56.7994 144V123.646C53.9385 123.342 51.2267 122.217 48.9902 120.406Z"
                    fill="#839EFF" />
                  <path
                    d="M68.0081 96.5543L82.3944 82.1635C76.302 76.6078 68.4547 73.3652 60.2188 73.0002V93.3541C63.0663 93.6594 65.768 94.7694 68.0081 96.5543Z"
                    fill="#839EFF" />
                  <path
                    d="M73.653 106.811H94.0006C93.6032 98.5719 90.3502 90.7287 84.8004 84.6282L70.4141 99.019C72.1977 101.264 73.3194 103.963 73.653 106.811Z"
                    fill="#839EFF" />
                  <path
                    d="M60.2188 123.646V144C68.4627 143.628 76.3159 140.379 82.4143 134.817L68.0081 120.406C65.7772 122.213 63.0727 123.338 60.2188 123.646Z"
                    fill="#839EFF" />
                  <path
                    d="M73.653 110.19C73.3266 113.052 72.2045 115.765 70.4141 118.021L84.8004 132.412C90.3588 126.301 93.6123 118.442 94.0006 110.19H73.653Z"
                    fill="#839EFF" />
                  <path
                    d="M43.3476 110.19H23C23.3982 118.416 26.6517 126.247 32.2001 132.332L46.5865 117.942C44.8014 115.713 43.679 113.026 43.3476 110.19Z"
                    fill="#839EFF" />
                  <path
                    d="M46.5865 98.9793L32.2001 84.6282C26.6346 90.7345 23.38 98.596 23 106.85H43.3476C43.6572 103.972 44.7807 101.242 46.5865 98.9793Z"
                    fill="#839EFF" />
                </g>
              </g>
              <defs>
                <clipPath id="clip0_4343_66862">
                  <rect width="181" height="212" fill="white" />
                </clipPath>
              </defs>
            </svg>

          </div>
          <div class="row" *ngIf="userImage != null">
            <svg width="181" height="180" style="margin-top: -15%;margin-left: 10%;" viewBox="0 0 181 212" fill="none"
              xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
              <g clip-path="url(#clip0_4339_64322)">
                <mask id="path-1-inside-1_4339_64322" fill="white">
                </mask>
                <g style="mix-blend-mode:multiply" opacity="0.7">
                  <path
                    d="M58 162C87.2711 162 111 138.271 111 109C111 79.7289 87.2711 56 58 56C28.7289 56 5 79.7289 5 109C5 138.271 28.7289 162 58 162Z"
                    stroke="#839EFF" stroke-miterlimit="10" />
                </g>
                <path
                  d="M57.5 150C80.4198 150 99 131.42 99 108.5C99 85.5802 80.4198 67 57.5 67C34.5802 67 16 85.5802 16 108.5C16 131.42 34.5802 150 57.5 150Z"
                  fill="url(#pattern0_4339_64322)" stroke="#839EFF" stroke-linecap="round" stroke-linejoin="round"
                  stroke-dasharray="1.8 4.5" />
              </g>
              <defs>
                <pattern id="pattern0_4339_64322" patternContentUnits="objectBoundingBox" width="1" height="1">
                  <use xlink:href="#image0_4339_64322" transform="translate(-0.251366) scale(0.00546448)" />
                </pattern>
                <clipPath id="clip0_4339_64322">
                  <rect width="181" height="212" fill="white" />
                </clipPath>
                <image id="image0_4339_64322" width="275" height="183" [attr.xlink:href]="userImage" />
              </defs>
            </svg>
          </div>
          <div class="d-flex  flex-column align-items-center justify-content-center" style="margin-top: -22%;">
            <div class="gap-3 mt-2">
              <div class="user_details">
                <span>
                  {{ userDetails.emailAddress | lowercase }}
                </span>
                <div>
                  {{ userDetails.designation }}
                </div>
                <div *ngIf="userDetails.managerName!=null">Manager: {{ userDetails.managerName }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-8 p-2">
          <div class="row ">
            <img *ngIf="oneQmsOrgImagesDetails.oneQmsImageFileName" class="org-image"
              src="../../assets/img/{{oneQmsOrgImagesDetails.oneQmsImageFileName}}" alt="logo"
              style="height: 30px;width: 50%;margin-left: 22%;">
          </div><br>
          <div class="row">
            <div class="d-flex gap-4">
              <div *ngIf="organizationPrivelegesData?.isTrainingUser =='Y'">
                <div class="headOfCircle">Training</div>
                <div>
                  <div class="totalTrainings">
                    {{ badgeName }}
                  </div>
                  <div>
                    <canvas class="chart" id="MyChartForTraining" [ngStyle]="addBadges(badgeName)"></canvas>
                  </div>
                </div>
              </div>
              <div *ngIf="organizationPrivelegesData?.isDocumentUser =='Y'">
                <div class="headOfCircle">Document</div>
                <canvas class="chart" id="MyChartForDocument"></canvas>
              </div>
              <div *ngIf="organizationPrivelegesData?.isQualityUser =='Y'">
                <div class="headOfCircle">Quality</div>
                <canvas class="chart" id="MyChartForQuality"></canvas>
              </div>
            </div>
          </div>

        </div>
      </div>
      <div class="row position-relative cr_content h-auto table-container thumbnail"
        style="border-radius: 15px; width:99%; margin-left:2px;height:614px; margin-top: 13px;">
        <highcharts-chart *ngIf="withLocalation" id="container" [Highcharts]="Highcharts" [constructorType]="'mapChart'"
          [options]="chartOptions" style="width: 100%; height: 614px; display: block;" #globalChart>
        </highcharts-chart>
        <highcharts-chart *ngIf="!withLocalation" id="container" [Highcharts]="Highcharts"
          [constructorType]="'mapChart'" [options]="chartOptions1" style="width: 100%; height: 614px; display: block;"
          #globalChart>
        </highcharts-chart>
      </div>

    </div>
  </div>
</div>
<ng-template #viewDatapopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelViewdataPopup()" mat-button>
      <i class="fa popupClose">&#xf00d;</i>
    </button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle">{{ popupVal }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
      </label>
    </div>

    <div mat-dialog-content>
      <div class="table-container"
        *ngIf="popupVal !='Incidents' && popupVal !='Complaints' && popupVal !='My Issuance History'">
        <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
          <div class="">
            <div class="search-container">
              <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
                [(ngModel)]="searchValue">
            </div>
          </div>
        </div>
        <table class="dynamic-table-container documentTable" style="height: 55vh !important;">
          <thead>
            <th *ngFor="let column of ColumnList"
              [ngStyle]="{'min-width': column.width, 'max-width': column.width, 'overflow': 'hidden', 'text-overflow': 'ellipsis', 'white-space': 'nowrap'}">
              <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-2">
                <span>{{column.name}}</span>
                <div class="d-flex gap-2 align-items-center">
                  <div>
                    <img src="../../../assets/img/qms_img/sort.svg" width="9px" height="16px" alt="sort" />
                  </div>
                </div>
              </div>
            </th>
          </thead>
          <tbody>
            <tr class="data-row-container" *ngFor="
              let data of pagedItems | searchFilter : searchValue;
              let idx = index
              ">
              <td class="row-data" *ngIf="popupVal =='Document'" style="
              min-width: 140px;
              color: blue;
              text-decoration: underline;
              cursor: pointer;
            " (click)="viewDoc(data)">
                {{ data.documentNo }}
              </td>
              <td *ngIf="popupVal =='Document'" class="row-data">{{ data.version }}</td>
              <td *ngIf="popupVal =='Document'" class="row-data">{{ data.documentName }}</td>
              <td *ngIf="popupVal =='Document'" class="row-data">{{ data.status }}</td>
              <td *ngIf="popupVal =='Document'" class="row-data">{{ data.documentTypeName }}</td>
              <td *ngIf="popupVal !='Document' && popupVal !='Team Users' && popupVal !='Saved Report'"
                class="row-data">{{ data.groupName }}</td>
              <td *ngIf="popupVal =='Trainings'" class="row-data">{{ data.trainingCnt }}</td>
              <td *ngIf="popupVal =='Trainings'" class="row-data">{{ data.trainingNames }}</td>
              <td *ngIf="popupVal =='Documents'" class="row-data">{{ data.folderCnt }}</td>
              <td *ngIf="popupVal =='Documents'" class="row-data">{{ data.folderList }}</td>
              <td *ngIf="popupVal =='Documents'" class="row-data">{{ data.userOrRoleName }}</td>
              <td *ngIf="popupVal =='Documents'" class="row-data">{{ data.dmsRoles }}</td>
              <td *ngIf="popupVal =='Quality'" class="row-data">{{ data.moduleCnt }}</td>
              <td *ngIf="popupVal =='Quality'" class="row-data">{{ data.qmsModules }}</td>
              <td *ngIf="popupVal =='Team Users'" class="row-data">{{ data.userName }}</td>
              <td *ngIf="popupVal =='Team Users'" class="row-data">{{ data.firstName }}</td>
              <td *ngIf="popupVal =='Team Users'" class="row-data">{{ data.lastName }}</td>
              <td *ngIf="popupVal =='Team Users'" class="row-data">{{ data.emailAddress | lowercase }}</td>
              <td *ngIf="popupVal =='Team Users'" class="row-data">{{ data.designation }}</td>
              <td *ngIf="popupVal =='Team Users'" class="row-data">{{ data.department }}</td>
              <td *ngIf="popupVal =='Saved Report'" class="row-data">{{ data.module }}</td>
              <td *ngIf="popupVal =='Saved Report'" class="row-data">{{ data.reportName }}</td>
              <td *ngIf="popupVal =='Saved Report'" class="row-data">{{ data.reportStatus }}</td>
              <td *ngIf="popupVal =='Saved Report'" class="row-data">
                <div class="download-button-continer btn-align" mat-dialog-actions>
                  <button class="d-flex align-items-center" mat-stroked-button class="downloadButton"
                    (click)="downloadSavedReport(data)">
                    <img src="../../../assets/img/cr_module/download.svg" width="12px" height="12px" alt="download">
                    Download
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
        <div class="d-flex justify-content-center">
          <div class="width-cheat small paginationCell">
            <div class="d-flex align-items-center gap-3">
              <div class="pagination_text mt-3">
                {{ showingRowsText }}
                1-{{ perPage }} of {{ collectionSize | number }}
              </div>
              <div>
                <ngb-pagination class="leftpadding" (pageChange)="setPage2(pager.currentPage, $event,popupList)"
                  [disabled]="false" [collectionSize]="pager.totalItems" [(page)]="pager.currentPage"
                  [maxSize]="maxSize" [rotate]="true" [pageSize]="perPage" [ellipses]="false" [boundaryLinks]="true"
                  size="sm">
                </ngb-pagination>
              </div>
              <div ngbDropdown class="mt-3">
                <button class="btn btn-primary btn-sm mr-1 bg-white pagination_text" id="dropdownBasic1"
                  ngbDropdownToggle>
                  {{ perPage }}
                  <i class="ms-1 fa-solid fa-chevron-down"></i>
                </button>
                <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
                  <button ngbDropdownItem (click)="paginationCall2(10,popupList)">10</button>
                  <button ngbDropdownItem (click)="paginationCall2(20,popupList)">20</button>
                  <button ngbDropdownItem (click)="paginationCall2(50,popupList)">50</button>
                </div>
                per page
              </div>
            </div>
          </div>
        </div>

      </div>
      <!-- </div> -->
      <div *ngIf="popupVal =='Incidents'">
        <app-raise-in [isFromHomePage]="true"></app-raise-in>
      </div>
      <div *ngIf="popupVal =='Complaints'">
        <app-raise-cc [isFromHomePage]="true"></app-raise-cc>
      </div>
      <div *ngIf="popupVal =='My Issuance History'">
        <app-document-issuance-history></app-document-issuance-history>
      </div>
    </div>
  </div>
</ng-template>
<div class="d-none row" *ngIf="showCharts">
  <div class="d-flex gap-5 col-md-12 mt-5">
    <div class="d-flex col-md-4 flex-column align-items-center profile_box" style="height:250px"
      *ngFor="let listOfUsersData of userDetails; let idx = index;">

      <span *ngIf="oneQmsUserImagesDetails != null || oneQmsUserImagesDetails != undefined">
        <!-- matTooltip="Upload logo"-->
        <img style="margin-top: -30px" src="data:image/*;base64,{{oneQmsUserImagesDetails.userImage}}" width="80px"
          height="75px" alt="profile" />
      </span>


      <div class="user">
        <span> {{listOfUsersData.firstName}},
          {{listOfUsersData.lastName}} </span>
      </div>
      <div class="d-flex gap-3 mt-2">
        <div class="user_details">
          <span>
            {{ listOfUsersData.emailAddress | lowercase }}
          </span>
        </div>
        <div class="user_details">
          <span>
            {{listOfUsersData.designation}}
          </span>
        </div>
      </div>
      <div class="d-flex gap-3 mt-2">
        <span class="user_details">Manager: {{ userDetails.managerName}}</span>

      </div>
      <div class="d-flex gap-4 mt-3">
        <div class="d-flex flex-column align-items-center pointer"
          (click)="openInformationPopup('Training Categories', $event)">
          <div class="training_group">
            <img src="../../assets/img/training_module/training_categories.svg" width="16px" height="16px"
              alt="training categories" />
          </div>
          <p class="training_info">Training Categories</p>
          <span class="count">{{ categoryCount }}</span>
        </div>
        <div class="d-flex flex-column align-items-center pointer"
          (click)="openInformationPopup('Training Groups', $event)">
          <div class="training_group my_total_request">
            <img src="../../assets/img/training_module/training_groups.svg" width="16px" height="16px"
              alt="training groups" />
          </div>
          <p class="training_info">Training Groups</p>
          <span class="count">{{ groupCount }}</span>
        </div>
        <div class="d-flex flex-column align-items-center pointer" (click)="openInformationPopup('Documents', $event)">
          <div class="training_group other_request">
            <img src="../../assets/img/training_module/documents.svg" width="16px" height="12px" alt="documents" />
          </div>
          <p class="training_info">Documents</p>
          <span class="count">{{ documentsCount }}</span>
        </div>
      </div>


      <hr>
    </div>
    <div class="col-md-8">
      <div class="row">
        <div class="col-md-6" *ngIf="grouphDataList.length >0 ">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsForGroup" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(1)"></canvasjs-chart>
          </div>
        </div>

        <div class="col-md-6" *ngIf="trainingCountList.length > 0">
          <div class="border rounded-4 p-2 mb-3">
            <div class="chart-container">
              <canvasjs-chart [options]="chartOptionsForTrainings" [styles]="{width: '100%', height:'250px'}"
                (dblclick)="homeChartDoubleClick(2)"></canvasjs-chart>
              <div class="badge-info">
                <img class="badge-icon" [src]="getBadgeImageUrl(badgeName)" alt="Badge Image">
                <div>{{badgeName}} {{countMyTr}}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-md-12" *ngIf="activityGroupIntervalList.length > 0">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsForAxis" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(3)"></canvasjs-chart>
          </div>
        </div>
        <div class="col-md-6" *ngIf="dmsGrouphDataList.length>0 ">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsForDmsGroup" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(4)"></canvasjs-chart>
          </div>
        </div>



        <div class="col-md-6" *ngIf="ecGrouphDataList.length >0">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsForEcGroup" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(5)"></canvasjs-chart>
          </div>
        </div>

        <div class="col-md-6" *ngIf="dmsGrouphDataList.length >0">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsDMSNstatus" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(6)"></canvasjs-chart>
          </div>
        </div>
        <div class="col-md-6" *ngIf="homeDMSStatusList.length >0">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsForDMSStatus" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(7)"></canvasjs-chart>
          </div>
        </div>
        <div class="col-md-6" *ngIf="actionList.length>0">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsAction" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(8)"></canvasjs-chart>
          </div>
        </div>

        <div class="col-md-6" *ngIf="riskList.length > 0">
          <div class="border rounded-4 p-2 mb-3">
            <canvasjs-chart [options]="chartOptionsRisk" [styles]="{width: '100%', height:'250px'}"
              (dblclick)="homeChartDoubleClick(9)"></canvasjs-chart>
          </div>
        </div>
        <div class="col-md-12"
          *ngIf="riskList.length==0 && actionList.length==0 && homeDMSStatusList.length==0 && dmsGrouphDataList.length==0 && ecGrouphDataList.length==0 && dmsGrouphDataList.length==0 && activityGroupIntervalList.length==0 && trainingCountList.length==0 && grouphDataList.length==0">
          <img src="../../assets/img/DMS/dashboardEmpty.png" alt="No Data" style="width: 900px; height: 700px;">
        </div>

      </div>
    </div>
  </div>
</div>


<ng-template #reportPopupForZoom>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelReportPopupForZoomFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"></label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>

  <div class="row">

    <div class="col-md-12" *ngIf="clickedChartVal==1">
      <canvasjs-chart [options]="chartOptionsForGroupZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==2">
      <canvasjs-chart [options]="chartOptionsForTrainingsZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==3">
      <canvasjs-chart [options]="chartOptionsForAxisZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==4">
      <canvasjs-chart [options]="chartOptionsForDmsGroupZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==5">
      <canvasjs-chart [options]="chartOptionsForEcGroupZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==6">
      <canvasjs-chart [options]="chartOptionsDMSNstatusZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==7">
      <canvasjs-chart [options]="chartOptionsForDMSStatusZoom"
        [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==8">
      <canvasjs-chart [options]="chartOptionsActionZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
    <div class="col-md-12" *ngIf="clickedChartVal==9">
      <canvasjs-chart [options]="chartOptionsRiskZoom" [styles]="{width: '100%', height:'550px'}"></canvasjs-chart>
    </div>
  </div>





  <div class="button-continer" mat-dialog-actions class="btn-align">
    <button mat-stroked-button class="cancelButton" (click)="cancelReportPopupForZoomFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>
<ng-template #topicPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="canceltopicPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Topics </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <app-oneqms-topics [topicData]=""></app-oneqms-topics>
</ng-template>
<ng-template #eventDetailPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <div class="loader_block">
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
      <span class="loader_dots"></span>
    </div>
  </div>
  <button class="close close-button" mat-button (click)="cancelEventsPopup()"><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Events </label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <mat-tab-group mat-stretch-tabs class="trainingtab mat-tab-container mat-elevation-z4" animationDuration="0ms"
    (selectedTabChange)="onTabChanged($event);" [(selectedIndex)]="selectedTabIndex">
    <mat-tab id="createdEvents" label="Created Events">
      <ng-template mat-tab-label>
        <span>Created Events</span>
      </ng-template>
      <div *ngIf="selectedTabIndex == 0">
        <app-user-events [data]="'Created'"></app-user-events>
      </div>
    </mat-tab>
    <mat-tab id="activeEvents" label="Active Events">
      <ng-template mat-tab-label>
        <span>Active Events</span>
      </ng-template>
      <div *ngIf="selectedTabIndex == 1">
        <app-user-events [data]="'Active'"></app-user-events>
      </div>

    </mat-tab>
    <mat-tab label="Inactive Events">
      <ng-template mat-tab-label>
        <span>Inactive Events</span>
      </ng-template>
      <div *ngIf="selectedTabIndex == 2">
        <app-user-events [data]="'Inactive'"></app-user-events>
      </div>
    </mat-tab>
  </mat-tab-group>
</ng-template>
<ng-template #notificationPopup>
  <button class="close close-button" (click)="cancelNotificationPopup()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Notifications</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="myTrainingLeftPlace" style="height: auto;max-height: 600px;overflow-y: auto;overflow-x: hidden;">
    <app-activity-notifications></app-activity-notifications>
  </div>
</ng-template>

<ng-template #bulkUploadPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelBulkUploadFunc()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Bulk Upload</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div>
    <app-add-document-from-popup (valueChange)="changeInChild($event)"></app-add-document-from-popup>
  </div>


</ng-template>

<ng-template #bulkDownloadPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelBulkDownloadFunc()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Bulk Download</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div>
    <app-folder-stucture [data]="'DOCUMENTFORDOWNLOAD'"
      (valueChange)="changeInFolderStructureChildForDownload($event)"></app-folder-stucture>
  </div>
  <div class="border-top">
    <div class="button-continer d-flex gap-3 justify-content-end py-2" mat-dialog-actions>
      <button mat-stroked-button class="training_btn d-flex gap-1 align-items-center" (click)="downloadDocFunc()">
        <img src="../../assets/img/DMS/download.svg" width="18px" height="18px" alt="download"> Download
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelBulkDownloadFunc()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<ng-template #uploadImagesPopup1>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelUploadLogoFunction()" mat-button><i
      style="font-size: 23px;color: blue;" class="fa">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }} </label>
  </div>
  <div style="margin: 10px 10px;">
    <div class="row">
      <div class="col-md-12" id="upload-btn-wrapper">
        <button class="btn">Choose image...</button>
        <input id="uploadInputValue" type="file" name="myfile" (change)="uploadImages($event);readURL($event)" />

        <div class="upload-val-container d-flex justify-content-center">
          <span id="logo-success-icon" class="far fa-check-circle"></span><span id="logo-success-msg">Image uploaded
            successfully</span>
          <span id="logo-error-icon" class="fas fa-exclamation-circle"></span><span id="logo-error-msg">Please upload
            JPG/JPEG or PNG images only</span>
          <span id="logo-required-icon" class="fas fa-exclamation-circle"></span><span id="logo-required-msg">Please
            upload the image</span>
          <span *ngIf="logosizeextended">
            <span class="fas fa-exclamation-circle"></span>
            <span>File size exceeds the limit (500KB). Please choose a smaller file</span>
          </span>
        </div>
        <div *ngIf="profileImage" class="row" style="justify-content:center;">
          <img [src]="profileImage" style="height:150px;width:160px;" />
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer" mat-dialog-actions class="btn-align">
    <button mat-stroked-button class="uploadButton" (click)="uploadLogoImage()">
      <i class="fas fa-upload"></i> Upload
    </button>
  </div>
</ng-template>
<ng-template #downloadPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDownloadFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle">Download</label>
    <label for="app-name" class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <app-document-download [selectedDocList]="selectedDocList" [isFrom]="'BULK'"
    (valueChange)="changeInChild1($event)"></app-document-download>
</ng-template>
<ng-template #infoPopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="okInfo()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Note</label>
    <label class="popupAppTitle">One<span style="color: gold">QMS</span>
    </label>
  </div>
  <div style="margin: 15px 15px">
    <div class="row">
      <div class="col-md-12">
        {{warningMsg}}
      </div>
    </div>
    <!-- <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="addButton" (click)="okInfo()">
        OK
      </button>
    </div> -->
    <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
      <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="okInfo()">
        <span class="reload_text text-white">OK</span>
      </div>
    </div>
  </div>
</ng-template>
<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupDataTitle.title }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <!-- <div class="col-md-12">
          <div><label for="email">Reason For Untag</label></div>
          <textarea id="deleteTextarea" type="text" class="input-filed-textarea" rows="4" cols="50"
            [(ngModel)]="deleteReason"></textarea>
        </div> -->
        <h3>Are you sure do you want to untag this record</h3>
      </div>
    </div>
    <div class="button-continer" mat-dialog-actions class="btn-align">
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction()">
        <i class="fa fa-trash"></i> Untag
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>
<app-top-navigation [hidden]="true"></app-top-navigation>
<app-document-viewer #viewPopup [docViewer]="docViewer" *ngIf="docViewer?.doc"></app-document-viewer>